var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemovePeople = function SvgRemovePeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.73333 1.33333C8.2 1.33333 9.4 2.53333 9.4 4C9.4 5.46667 8.2 6.66667 6.73333 6.66667C5.26667 6.66667 4.06667 5.46667 4.06667 4C4.06667 2.53333 5.26667 1.33333 6.73333 1.33333ZM6.73333 0C4.53333 0 2.73333 1.8 2.73333 4C2.73333 6.2 4.53333 8 6.73333 8C8.93333 8 10.7333 6.2 10.7333 4C10.7333 1.8 8.93333 0 6.73333 0ZM0 12.6667V11.3333H5.33333V12.6667H0ZM5.33333 8.86667C5.8 8.73333 6.2 8.66667 6.66667 8.66667C9.6 8.66667 12 11.0667 12 14H10.6667C10.6667 11.8 8.86667 10 6.66667 10C6.2 10 5.73333 10.0667 5.33333 10.2667V8.86667Z"
  })));
};
export default SvgRemovePeople;